<template>
    <div class="grid grid--column">
        <slot></slot>
    </div>
</template>
<style lang="scss"></style>
